import React from 'react'
import { HandleOuterClicksContext } from 'services/HandleOuterClicks'

export default function useOnClickOutside (ref, callback, dependencies = []) {
  const handleOuterClicksContext = React.useContext(HandleOuterClicksContext)

  React.useEffect(() => {
    return handleOuterClicksContext.onClick((event) => {
      if (ref && typeof (ref.contains) === 'function' && !ref.contains(event.target)) {
        callback(event)
      }
    })
  }, [ref, ...dependencies])
}
